import React, { useEffect, useLayoutEffect, useRef, useState, } from 'react';
import ManuCard from './MenuCard'
import { Link, Element } from 'react-scroll';
import CartCategory from '../Cart/CartCategory';
import { connect, useSelector } from 'react-redux';
import { getComboDetail, getItemDetail, storeMenuItemCall } from '../../Redux';
import { Modal } from 'react-bootstrap';
import { priceunit } from '../../Components/client-config';
import MenuBox from './MenuBox';
import ComboMenuBox from './ComboMenuBox';
import SkeletonCard from '../../Assetes/SkeletonLoader/SkeletonCard';
import useTrackEvent from '../../hooks/useTrackHook';
import SelectStoreModal from '../../Components/selectStoreModal';
import JazzCashOnly from '../../Components/JazzCashOnly';
import SuggestiveProducts from './SuggestiveProducts';
import mergn from 'mergn-webapp-sdk'
import _ from 'lodash';
import ItemCategories from './itemCategory';
import useCurrentLocale from '../../hooks/useLanguage';
import { COUNTRY_NAME } from '../../lib';

function Category(props: any) {
  let groups = useSelector((state: any) => state.menu.groups);
  let groupsData = useSelector((state: any) => state.menu.groupsData);
  const comboData = useSelector((state: any) => state.menu.comboData);
  const itemData = useSelector((state: any) => state.menu.itemData);
  const cartData = useSelector((state: any) => state.cart.cartData);
  const [show, setShow] = useState(false);
  const [comboOpen, setComboOpen] = useState(false);
  const [selectStoreShow, setSelectStoreModal] = useState(false);
  const handleSelectStoreClose = () => setSelectStoreModal(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const handleComboClose = () => setComboOpen(false);
  const handleComboOpen = () => setComboOpen(true);
  const [isScrolling, setIsScrolling] = useState(false);
  const ref = useRef<HTMLDivElement | null>(null);
  const storeSelected = useSelector((state: any) => state.store.storeSelected);
  const orderType = useSelector((state: any) => state.payment.orderType);
  const homeClickCategory = useSelector(
    (state: any) => state.menu.homeClickCategory
  );
  const [addEvent] = useTrackEvent();
  const pathname = window.location.pathname;
  const [selectJCShow, setSelectJCModal] = useState(false);
  const [ModalCat, setModalCat] = useState('')
  const [showSuggDeal, setShowSuggestiveDeal] = useState(false);
  const [normalDealData, setNormalDealData]: any = useState(null)
  const [normalItemData, setNormalItemData]: any = useState(null)
  const [showSuggProductOutSide, setShowSuggProductOutSide] = useState(false);
  const lang = useCurrentLocale();

  useEffect(() => {
    if (storeSelected) {
      props.storeMenuItemCall(storeSelected.store_id, orderType, pathname,lang)
    } else {
      props.storeMenuItemCall(null, orderType, pathname,lang)
    }
    let hashValue = window.location.hash;
    if (hashValue) {
      let urlProduct = hashValue.split(`/`);
      if (urlProduct[1]) {
        let product_id = urlProduct[1].split("_")
        if (urlProduct[0] == "#combo") {
          props.getComboDetail( orderType, product_id[1], handleComboOpen);
        } else if (urlProduct[0] == "#item") {
          props.getItemDetail( orderType, product_id[1], handleShow);
        }
      }
    }
  }, []);

  useEffect(() => {
    let scrollTimeout: any;
    const handleScroll = () => {

      setIsScrolling(true);
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(() => {
        setIsScrolling(false);
      }, 100);


      const scrollPosition = window.scrollY;
      const viewportWidth = window.innerWidth;

      if (viewportWidth < 525 && ref.current) {
        const maxScrollPosition = -400;
        const directionMultiplier = lang === 'ar' ? 1 : -1;
        const translateX = (scrollPosition / 20) * directionMultiplier;
        // const translateX = scrollPosition / -20;

        if (translateX >= maxScrollPosition) {
          ref.current.style.transform = `translateX(${translateX}px)`;
        } else {
          ref.current.style.transform = `translateX(${maxScrollPosition}px)`;
          window.addEventListener('scroll', handleScroll);
        }

        if (viewportWidth < 525 && ref.current) {
          const maxScrollPosition = 500;
          const translateX = Math.min(scrollPosition / -20, 0); // TranslateX should not go below 0

          ref.current.style.transform = `translateX(${translateX}px)`;

          // Adjust the width based on scroll position
          const initialWidth = 100; // Initial width in percentage
          const maxWidthChange = 140; // Maximum width change in percentage

          const newWidth = initialWidth + (scrollPosition / maxScrollPosition) * maxWidthChange;
          ref.current.style.width = `${Math.min(newWidth, initialWidth + maxWidthChange)}%`;
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const handleSelectJSToogle = () => {
    if (ModalCat === 'item' && itemData.item_size && itemData.item_size[0].is_jazz_cash === 1) {
      setSelectJCModal((prev) => {
        return !prev
      })
    }
    if (ModalCat === 'combos' && (comboData && comboData.is_jazz_cash && comboData.is_jazz_cash == 1)) {
      setSelectJCModal((prev) => {
        return !prev
      })
    }
  }

  const selectedItem = (item: any) => {
    if (item.item_size && item.item_size[0].is_jazz_cash === 1) {
      setModalCat('item')
    }
    if (item.combo_id && item.is_jazz_cash === 1) {
      setModalCat('combos')
    }
    if (item.menu_item_id && item.menu_item_id > 0) {
      props.getItemDetail(orderType, item.menu_item_id, handleShow)
    }
    if (item.combo_id && item.combo_id > 0) {
      props.getComboDetail(orderType, item.combo_id, handleComboOpen)
    }
    let products: any = []
    let MapObj: any = {}

    if (item.menu_item_id && item.menu_item_id > 0) {
      MapObj = {
        price: item.item_size && priceunit + item.item_size[0].mrp,
        id: item.menu_item_id,
        name: item.item_name,

      }
    }
    else if (item.combo_id && item.combo_id > 0) {
      MapObj = {
        price: item.combo_mrp_price,
        id: item.combo_id,
        name: item.item_name,
      }
    }
    props.setTitle(item.meta_title)
    props.setMeta(item.meta_description)
    products.push(MapObj)

    let windowObj = (window as any)
    windowObj.dataLayer.push({ ecommerce: null });
    windowObj.dataLayer.push({
      'event': 'select_item',
      'ecommerce': {
        'item_list_id': item?.item_group_id?.group_id ? item.item_group_id.group_id : item.group_id.group_id,
        'item_list_name': item?.item_group_id?.group_name ? item.item_group_id.group_name : item.group_id.group_name,
        'items': [
          {
            'item_id': item.menu_item_id || item.combo_id,
            'item_name': item.item_name || item.combo_name,
            'item_category': item?.item_group_id?.group_name ? item.item_group_id.group_name : item.group_id.group_name,
            'price': item.item_size && item.item_size[0].mrp ? item.item_size[0].mrp : item.combo_mrp_price,
          }
        ]
      }
    });
    let promotion_item = {
      id: item?.item_group_id?.group_id == 7 && item.menu_item_id,
      name: item?.item_group_id?.group_id == 7 && item.item_name,
      price: item?.item_group_id?.group_id == 7 && item.item_size?.length > 0 && item.item_size[0].mrp
    }

    windowObj.dataLayer.push({ ecommerce: null });
    windowObj.dataLayer.push({
      'event': 'select_promotion',
      'ecommerce': promotion_item
    });
  }

  const viewItemList = (group_id: any, group_name: any) => {

    let items: any = []

    groupsData.map((group: any) => {
      if (group.group_id === group_id) {
        group.data.map((product: any) => {
          let MapObj: any = {}
          if (product.menu_item_id) {
            MapObj = {
              price: product.item_size && product.item_size[0].mrp,
              item_id: product.menu_item_id,
              item_name: product.item_name,
              index: product.priority,
            }
          }
          else if (product.combo_id) {
            MapObj = {
              price: product.combo_mrp_price,
              item_id: product.combo_id,
              item_name: product.combo_name,
              index: product.priority
            }
          }
          items.push(MapObj)
        })
      }
    })

    let windowObj = (window as any)
    windowObj.dataLayer.push({ ecommerce: null });
    windowObj.dataLayer.push({
      'event': 'view_item_list',
      'ecommerce': {
        'item_list_id': group_id,
        'item_list_name': group_name,
        'items': items
      }
    });
  }

  const CloseCompoment = () => {
    handleClose()
    handleComboClose()
    props.setTitle(`KFC ${COUNTRY_NAME} | Deals & Offers`)
    props.setMeta("Kentucky Fried Chicken provides the best, the most scrumptiously crispy fried chicken and zinger burgers that will leave your mouth watering for more")

    if (window.location.hash) {
      window.history.replaceState("", document.title, window.location.pathname);
    }
  };
  const closeSuggCompoment = () => {
    setShowSuggProductOutSide(false);
    setShowSuggestiveDeal(false);
    setNormalDealData(null);
    setNormalItemData(null);
  };

  // ===react scroll offset===

  // To false of showSuggDeal in the case of 0 suggestive products show because setShowSuggestiveDeal
  // is calling only on selected item function of suggestive products component
  useEffect(() => {
    {
      (!_.isEmpty(comboData) && comboData.child_products && comboData.child_products.length > 0) && comboData.child_products
        .map((obj: any) => {
          obj.suggestive_child_products.length > 0 && obj.suggestive_child_products.filter((childProduct: any) => {
            return childProduct.suggestive_combo_id ? (!cartData.some((obj: any) => obj.combo && obj.combo.combo_id == childProduct.suggestive_combo_id.combo_id) && childProduct.suggestive_combo_id.is_suggestive == 1) : (!cartData.some((obj: any) => obj.item && obj.item.menu_item_id == childProduct.suggestive_item_id.menu_item_id) && childProduct.suggestive_item_id.is_suggestive == 1)
          }).length == 0 && setShowSuggestiveDeal(false);
        })
    }
    {
      (!_.isEmpty(itemData) && itemData.child_products && itemData.child_products.length > 0) && itemData.child_products
        .map((obj: any) => {
          obj.suggestive_child_products.length > 0 && obj.suggestive_child_products.filter((childProduct: any) => {
            return childProduct.suggestive_combo_id ? (!cartData.some((obj: any) => obj.combo && obj.combo.combo_id == childProduct.suggestive_combo_id.combo_id) && childProduct.suggestive_combo_id.is_suggestive == 1) : (!cartData.some((obj: any) => obj.item && obj.item.menu_item_id == childProduct.suggestive_item_id.menu_item_id) && childProduct.suggestive_item_id.is_suggestive == 1)
          }).length == 0 && setShowSuggestiveDeal(false);
        })
    }
    {
      (!_.isEmpty(normalDealData) && normalDealData.child_products && normalDealData.child_products.length > 0) && normalDealData.child_products
        .map((obj: any) => {
          obj.suggestive_child_products.length > 0 && obj.suggestive_child_products.filter((childProduct: any) => {
            return childProduct.suggestive_combo_id ? (!cartData.some((obj: any) => obj.combo && obj.combo.combo_id == childProduct.suggestive_combo_id.combo_id) && childProduct.suggestive_combo_id.is_suggestive == 1) : (!cartData.some((obj: any) => obj.item && obj.item.menu_item_id == childProduct.suggestive_item_id.menu_item_id) && childProduct.suggestive_item_id.is_suggestive == 1)
          }).length == 0 && setShowSuggProductOutSide(false);
        })
    }
    {
      (!_.isEmpty(normalItemData) && normalItemData.child_products && normalItemData.child_products.length > 0) && normalItemData.child_products
        .map((obj: any) => {
          obj.suggestive_child_products.length > 0 && obj.suggestive_child_products.filter((childProduct: any) => {
            return childProduct.suggestive_combo_id ? (!cartData.some((obj: any) => obj.combo && obj.combo.combo_id == childProduct.suggestive_combo_id.combo_id) && childProduct.suggestive_combo_id.is_suggestive == 1) : (!cartData.some((obj: any) => obj.item && obj.item.menu_item_id == childProduct.suggestive_item_id.menu_item_id) && childProduct.suggestive_item_id.is_suggestive == 1)
          }).length == 0 && setShowSuggProductOutSide(false);
        })
    }
  }, [
    itemData,
    comboData,
    normalItemData,
    normalDealData,
    showSuggDeal,
    showSuggProductOutSide,
  ]);

  const [activeCategory, setActiveCategory] = useState<string>("");

  useEffect(() => {
    function handleScroll() {
      const groupNames = groups?.map((group: { group_name: any }) =>
        group.group_name.replace(/\s+/g, "")
      );

      let currentSection = "";
      groupNames?.forEach((group_name: any) => {
        const element = document.getElementById(group_name);
        if (element) {
          const rect = element.getBoundingClientRect();
          const sectionTop = rect.top;
          const sectionBottom = rect.bottom;
          if (
            sectionTop < window.innerHeight / 3 &&
            sectionBottom > window.innerHeight / 3
          ) {
            currentSection = group_name;
          }
        }
      });
      setActiveCategory(currentSection || "");
    }

    window.addEventListener("scroll", handleScroll);
    handleScroll();

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [groups]);

  useEffect(() => {
    if (!activeCategory) return;
    const newHash = `#${activeCategory}`;
    if (window.location.hash !== newHash) {
      window.history.replaceState(null, "", newHash);
    }
  }, [activeCategory]);

  useEffect(() => {
    const hash = window.location.hash.substring(1);
    if (!hash || !groupsData || groupsData.length === 0) return;

    // Decode the hash in case it has encoded characters (Arabic, French, etc.)
    const group_name = decodeURIComponent(hash);
    const scrollToCategory = () => {
      const element = document.getElementById(group_name);
      if (!element) return;

      const elementTop = element.getBoundingClientRect().top;
      const isMobile = window.innerWidth < 768;
      const offset = isMobile ? 180 : 150;
      const scrollPosition = window.scrollY + elementTop - offset;
      window.scrollTo({
        top: scrollPosition,
        behavior: "smooth",
      });
      return true;
    };

    // Retry mechanism to wait for DOM to be ready
    let attempts = 0;
    const maxAttempts = 20; // Try for up to 2 seconds (20 * 100ms)

    const tryScroll = () => {
      if (scrollToCategory()) {
        return; // Success
      }

      attempts++;
      if (attempts < maxAttempts) {
        setTimeout(tryScroll, 100);
      } else {
        console.error('Failed to find element after', maxAttempts, 'attempts. Hash:', group_name);
      }
    };

    // Start trying after a short initial delay
    const timer = setTimeout(tryScroll, 200);

    return () => clearTimeout(timer);
  }, [groupsData]);

  // Listen to hash changes for navigation from BrowseCategories
  useEffect(() => {
    const handleHashChange = () => {
      const hash = window.location.hash.substring(1);
      if (!hash) return;

      const group_name = decodeURIComponent(hash);
      console.log('Hash changed to:', group_name);

      const scrollToElement = () => {
        const element = document.getElementById(group_name);
        if (!element) {
          console.log('Element not found in hashchange handler:', group_name);
          return false;
        }
        const elementTop = element.getBoundingClientRect().top;
        const isMobile = window.innerWidth < 768;
        const offset = isMobile ? 180 : 150;
        const scrollPosition = window.scrollY + elementTop - offset;
        window.scrollTo({
          top: scrollPosition,
          behavior: "smooth",
        });
        return true;
      };

      // Retry mechanism
      let attempts = 0;
      const maxAttempts = 15;

      const tryScroll = () => {
        if (scrollToElement()) {
          return;
        }

        attempts++;
        if (attempts < maxAttempts) {
          setTimeout(tryScroll, 100);
        } else {
          console.error('Hashchange: Failed to find element after', maxAttempts, 'attempts. Hash:', group_name);
        }
      };

      setTimeout(tryScroll, 50);
    };

    window.addEventListener('hashchange', handleHashChange);
    return () => window.removeEventListener('hashchange', handleHashChange);
  }, []);

  return (
    <div>
      <ItemCategories categories={groups} activeCategory={activeCategory} />
      <div className="main-height">
        <div className="container-xxl category-container-custom mt-170 mb-md-100">
          <div className="row">
            <div className="col-lg-8 col-md-12">
              {groupsData?.length > 0 ? (
                groupsData.map(
                  (
                    group: {
                      group_id: string;
                      group_name: string;
                      dataLength: number;
                      data: any[];
                    },
                    index: any
                  ) => {
                    return (
                      group.dataLength > 0 && (
                        <div
                          className={`main-menu-container`}
                          key={index}
                          id={group.group_name.replace(/\s+/g, "")}
                          data-category={group.group_id}
                        >
                          <h2 className={`menu-title mt-0`}>
                            {group.group_name}
                          </h2>

                          <div className="row">
                            {group.data.map((product, index) => (
                              <div className="col-lg-4 col-md-4 col-6 px-larg-4">
                                <ManuCard
                                  setShowSuggProductOutSide={
                                    setShowSuggProductOutSide
                                  }
                                  setNormalDealData={setNormalDealData}
                                  setNormalItemData={setNormalItemData}
                                  product={product}
                                  selectedItem={selectedItem}
                                  setHeaderUpdate={props.setHeaderUpdate}
                                  headerUpdate={props.headerUpdate}
                                />
                              </div>
                            ))}
                          </div>
                        </div>
                      )
                    );
                  }
                )
              ) :
                <>
                  <SkeletonCard />
                  <SkeletonCard />
                </>
              }
            </div>
            <div className="col-lg-4 col-md-8">
              <CartCategory setHeaderUpdate={props.setHeaderUpdate} headerUpdate={props.headerUpdate} />
            </div>
          </div>
        </div>
      </div>
      {show &&
        <Modal show={show} onHide={CloseCompoment} backdrop="static" keyboard={false} size="lg" centered>
          <div className='modal-design'>
            <span></span>
            <span></span>
            <span></span>
          </div>
          <Modal.Header className='p-0 border-0' closeButton />
          <MenuBox setShowSuggestiveDeal={setShowSuggestiveDeal} handleClose={CloseCompoment} setSelectStoreModal={setSelectStoreModal} handleToogle={handleSelectJSToogle} />
        </Modal>
      }
      {comboOpen &&
        <Modal show={comboOpen} onHide={CloseCompoment} backdrop="static" keyboard={false} size="lg" centered>
          <div className='modal-design'>
            <span></span>
            <span></span>
            <span></span>
          </div>
          <Modal.Header className='p-0 border-0' closeButton />
          <ComboMenuBox setShowSuggestiveDeal={setShowSuggestiveDeal} handleClose={CloseCompoment} setSelectStoreModal={setSelectStoreModal} handleToogle={handleSelectJSToogle} />
        </Modal>
      }
      <SelectStoreModal show={selectStoreShow} handleClose={handleSelectStoreClose} />
      <JazzCashOnly show={selectJCShow} handleToogle={handleSelectJSToogle} />
      {(!_.isEmpty(comboData) && comboData.child_products && comboData.child_products.length > 0) && comboData.child_products
        .map((obj: any) => {
          return obj.suggestive_child_products.length > 0 && obj.suggestive_child_products.filter((childProduct: any) => {
            return childProduct.suggestive_combo_id ? (!cartData.some((obj: any) => obj.combo && obj.combo.combo_id == childProduct.suggestive_combo_id.combo_id) && childProduct.suggestive_combo_id.is_suggestive==1) : (!cartData.some((obj: any) => obj.item && obj.item.menu_item_id == childProduct.suggestive_item_id.menu_item_id) && childProduct.suggestive_item_id.is_suggestive==1)
          }).length > 0 && showSuggDeal && <SuggestiveProducts comboData={comboData} itemData={itemData} handleShow={handleShow} handleComboOpen={handleComboOpen} showSuggDeal={showSuggDeal} closeSuggCompoment={closeSuggCompoment} />
        })}
      {(!_.isEmpty(itemData) && itemData.child_products && itemData.child_products.length > 0) && itemData.child_products
        .map((obj: any) => {
          return obj.suggestive_child_products.length > 0 && obj.suggestive_child_products.filter((childProduct: any) => {
            return childProduct.suggestive_combo_id ? (!cartData.some((obj: any) => obj.combo && obj.combo.combo_id == childProduct.suggestive_combo_id.combo_id) && childProduct.suggestive_combo_id.is_suggestive==1) : (!cartData.some((obj: any) => obj.item && obj.item.menu_item_id == childProduct.suggestive_item_id.menu_item_id) && childProduct.suggestive_item_id.is_suggestive==1)
          }).length > 0 && showSuggDeal && <SuggestiveProducts comboData={comboData} itemData={itemData} handleShow={handleShow} handleComboOpen={handleComboOpen} showSuggDeal={showSuggDeal} closeSuggCompoment={closeSuggCompoment} />
        })}
      {/* OutSide Combo Add To Cart Button */}
      {(!_.isEmpty(normalDealData) && normalDealData.child_products && normalDealData.child_products.length > 0) && normalDealData.child_products
        .map((obj: any) => {
          return obj.suggestive_child_products.length > 0 && obj.suggestive_child_products.filter((childProduct: any) => {
            return childProduct.suggestive_combo_id ? (!cartData.some((obj: any) => obj.combo && obj.combo.combo_id == childProduct.suggestive_combo_id.combo_id) && childProduct.suggestive_combo_id.is_suggestive==1) : (!cartData.some((obj: any) => obj.item && obj.item.menu_item_id == childProduct.suggestive_item_id.menu_item_id) && childProduct.suggestive_item_id.is_suggestive==1)
          }).length > 0 && showSuggProductOutSide && <SuggestiveProducts comboData={normalDealData} itemData={null} handleShow={handleShow} handleComboOpen={handleComboOpen} showSuggDeal={showSuggProductOutSide} closeSuggCompoment={closeSuggCompoment} />
        })}
      {/* OutSide Item Add To Cart Button */}
      {(!_.isEmpty(normalItemData) && normalItemData.child_products && normalItemData.child_products.length > 0) && normalItemData.child_products
        .map((obj: any) => {
          return obj.suggestive_child_products.length > 0 && obj.suggestive_child_products.filter((childProduct: any) => {
            return childProduct.suggestive_combo_id ? (!cartData.some((obj: any) => obj.combo && obj.combo.combo_id == childProduct.suggestive_combo_id.combo_id) && childProduct.suggestive_combo_id.is_suggestive==1) : (!cartData.some((obj: any) => obj.item && obj.item.menu_item_id == childProduct.suggestive_item_id.menu_item_id) && childProduct.suggestive_item_id.is_suggestive==1)
          }).length > 0 && showSuggProductOutSide && <SuggestiveProducts comboData={null} itemData={normalItemData} handleShow={handleShow} handleComboOpen={handleComboOpen} showSuggDeal={showSuggProductOutSide} closeSuggCompoment={closeSuggCompoment} />
        })}
    </div>
  )
}


const mapDispatchToProps = (dispatch: any) => {
  return {
    storeMenuItemCall: (store_id: any, orderType: any, pathname: string,locale: string) => {
      dispatch(storeMenuItemCall(store_id, orderType, pathname,locale))
    },
    getItemDetail: (orderType: any, id: any, handleShow:any) => {
      dispatch(getItemDetail(orderType, id, handleShow))
    },
    getComboDetail: (orderType: any, id: any, handleComboOpen:any) => {
      dispatch(getComboDetail(orderType, id, handleComboOpen))
    },
  };
};
export default connect(null, mapDispatchToProps)(Category);